// @ts-nocheck
import constants from "@store/constants";

export default () =>
    document?.querySelector("header")?.getBoundingClientRect().height || constants.defaultHeaderHeight.mainHeight;
